module.exports = __webpack_public_path__ + "media/icon/edit-button-3dee94ad.svg";